"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VCardPanel = void 0;
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var react_1 = __importStar(require("react"));
var Collapse = core_1.Collapse;
var VCardPanel = (function (_super) {
    __extends(VCardPanel, _super);
    function VCardPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCollapsed = function () {
            var isOpen = _this.state.isOpen;
            _this.setState(__assign(__assign({}, _this.state), { isOpen: !isOpen }));
        };
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    VCardPanel.prototype.componentDidMount = function () {
        this.setState({ isOpen: this.props.defaultActive || false });
    };
    VCardPanel.prototype.render = function () {
        var _a = this.props, children = _a.children, backgroundColor = _a.backgroundColor, cardElevation = _a.cardElevation, height = _a.height, width = _a.width, collapse = _a.collapse, transitionDuration = _a.transitionDuration, bodyPadding = _a.bodyPadding, keepChildrenMounted = _a.keepChildrenMounted, noHeader = _a.noHeader, className = _a.className, id = _a.id;
        var isOpen = this.state.isOpen;
        return (react_1.default.createElement(style_1.VCard, { elevation: cardElevation || 0, height: height, className: className, collapse: collapse ? 'true' : 'false', transitionduration: transitionDuration, isopen: isOpen ? 'true' : 'false', width: width, id: id },
            !noHeader ? (react_1.default.createElement(style_1.VCardHeader, { headerBackgroundColor: this.props.headerBackgroundColor, headerOrientation: this.props.headerOrientation, headerJustifyContent: this.props.headerHorizontalAlign, heigthHeaderPx: this.props.heigthHeaderPx, onMouseDown: this.props.onHeaderMouseDrag, onClick: this.props.onHeaderFocus, className: this.props.headerClass },
                react_1.default.createElement(style_1.VCardTextSpanContainer, null, this.props.headerTextComponent ? (react_1.default.createElement(style_1.VCardTextSpan, null, this.props.headerTextComponent)) : (react_1.default.createElement(style_1.VCardTextSpan, { headerColor: this.props.headerColor, headerTextJustify: this.props.headerTextJustify, headerTextUppercase: this.props.headerTextUppercase, headerTextBold: this.props.headerTextBold },
                    this.props.headerCustomButton,
                    this.props.headerIcon ? (react_1.default.createElement(core_1.Icon, { icon: this.props.headerIcon })) : null,
                    react_1.default.createElement("span", null, this.props.headerText)))),
                this.props.collapse ? (react_1.default.createElement("span", { onClick: this.toggleCollapsed },
                    react_1.default.createElement(core_1.Icon, { icon: this.state.isOpen
                            ? this.props.closeIcon || 'chevron-up'
                            : this.props.openIcon || 'chevron-down' }))) : null,
                this.props.headerCustomComponent ? (react_1.default.createElement("div", null, this.props.headerCustomComponent)) : null)) : null,
            react_1.default.createElement(style_1.VCardBody, { bodyPadding: bodyPadding, backgroundColor: backgroundColor }, collapse ? (react_1.default.createElement(Collapse, { transitionDuration: transitionDuration || 200, keepChildrenMounted: keepChildrenMounted, isOpen: isOpen }, children)) : (children))));
    };
    return VCardPanel;
}(react_1.Component));
exports.VCardPanel = VCardPanel;
